// extracted by mini-css-extract-plugin
export default {"host":"Page_host__NBenm"};